export const requestStatus = { OK: "OK", ERROR: "ERROR" };
